import { useEffect, useState } from "react";

export function useHasMediaDevice(kind: MediaDeviceKind) {
  const [has, setHas] = useState(false);

  useEffect(() => {
    if (!navigator.mediaDevices?.enumerateDevices) {
      setHas(false);
      return;
    }

    const update = () =>
      navigator.mediaDevices
        .enumerateDevices()
        .then((d) => setHas(d.some((i) => i.kind === kind)))
        .catch(() => setHas(false));

    update(); // فراخوان نخست
    navigator.mediaDevices.addEventListener("devicechange", update);

    return () =>
      navigator.mediaDevices.removeEventListener("devicechange", update);
  }, [kind]);

  return has;
}

export type TrackStatus =
  | "idle"
  | "requesting"
  | "ready"
  | "denied"
  | "unavailable";

export const TRACK_ERROR_STATUS: Record<string, TrackStatus> = {
  NotAllowedError: "denied",
  SecurityError: "denied",
  AbortError: "denied",
  NotFoundError: "unavailable",
  OverconstrainedError: "unavailable",
  NotReadableError: "unavailable",
  UnknownError: "unavailable",
} as const;

export const SILENT_ERRORS = Object.keys(TRACK_ERROR_STATUS);
